import React, {useMemo, useState} from 'react';
import {HistoryList} from 'Components/HistoryList';
import {getAIHistory} from 'Common/api';
import {useUserContext} from 'Contexts/UserContext/UserContext';
import {Waitlist} from './Waitlist';

interface Props {}

const AssistantURL =
    process.env.NODE_ENV === 'production' ? 'https://www.renditioncreate.com/p' : 'http://localhost:3000/p';

export const Dashboard = (props: Props) => {
    const [page, setPage] = useState(0);

    const [shouldDisablePrev, setShouldDisablePrev] = useState(false);
    const [shouldDisableNext, setShouldDisableNext] = useState(false);

    const {userId, user} = useUserContext();

    const AIHistoryKey = useMemo(() => ({userId, page, key: 'ai-history'}), [page, userId]);

    const showWaitlist = user?.waitlist && !user.paid;

    return (
        <div className="flex w-full flex-col p-8">
            {showWaitlist && (
                <div className="m-auto">
                    <Waitlist />
                </div>
            )}
            {!showWaitlist && (
                <>
                    <h1 className={"  font-['Inter'] text-sm "}>Rendition Assistant</h1>
                    <div className="flex w-full flex-col place-items-start gap-8 py-8 lg:h-full">
                        <HistoryList
                            page={page}
                            setShouldDisablePrev={setShouldDisablePrev}
                            setShouldDisableNext={setShouldDisableNext}
                            fetcher={getAIHistory}
                            args={AIHistoryKey}
                            idGetter={(data) => data.id!}
                            imageGetter={(data) => data.renditionExtraConfig?.screenshotUrl}
                            dateGetter={(data) => data.createdAt}
                            linkGetter={(data) => `${AssistantURL}/${data.id}`}
                        />
                        <div className="mt-auto flex flex-col items-start justify-start gap-2">
                            <div className="flex flex-row gap-4">
                                <button
                                    disabled={shouldDisablePrev}
                                    className="appearance-none border-none text-xs font-medium text-neutral-700 hover:underline disabled:opacity-40 disabled:hover:no-underline"
                                    onClick={() => setPage(page - 1)}
                                >
                                    Prev
                                </button>
                                <button
                                    disabled={shouldDisableNext}
                                    className="appearance-none border-none text-xs font-medium text-neutral-700 hover:underline disabled:opacity-40 disabled:hover:no-underline"
                                    onClick={() => setPage(page + 1)}
                                >
                                    Next Page
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};
